// extracted by mini-css-extract-plugin
export default {"priceContainer":"PricingTime_priceContainer__uX7Nm","label":"PricingTime_label__mqzQ9","error":"PricingTime_error__pGG6B"};